export default __webpack_public_path__ + "static/shop-image3-2b0c7fcacc0c3add3847d47d7799dea3.jpg";